import { Box, HStack, Text } from "@chakra-ui/react";

export function ToggleChoice({
  value,
  onChange,
  title,
}: {
  value: string;
  onChange: (value: string) => void;
  title: string;
}) {
  return (
    <Box
      display="flex"
      flexDirection={{ base: "column", sm: "row" }}
      justifyContent="space-between"
      alignItems={{ base: "flex-start", sm: "center" }}
      gap={4}
      p={4}
      bg="gray.50"
      borderRadius="xl"
    >
      <Text fontSize="sm" fontWeight="medium" color="gray.700" maxW="2xl">{title}</Text>
      <HStack gap={0} flexShrink={0}>
        <Box display="inline-flex" borderRadius="full" borderWidth="1px" borderColor="gray.200" bg="white" p={1}>
          {[
            { id: "si", label: "Sí" },
            { id: "no", label: "No" },
          ].map((option) => {
            const isActive = value === option.id;
            return (
              <Box
                key={option.id}
                onClick={() => onChange(option.id)}
                borderRadius="full"
                px={4}
                py={1.5}
                fontSize="sm"
                fontWeight="medium"
                transition="all 0.2s"
                bg={isActive ? "palomma.500" : "transparent"}
                color={isActive ? "white" : "gray.500"}
                cursor="pointer"
                _hover={isActive ? {} : { color: "gray.900" }}
              >
                {option.label}
              </Box>
            );
          })}
        </Box>
      </HStack>
    </Box>
  );
}
